<template lang="html">
  <img class="mt-3 mb-3" src="@/assets/logo.svg" alt="logo" width="200" />
  <h1 class="title">
    Waar mag jouw bedrijf best wat extra wind in de zeilen krijgen? (meerdere
    antwoorden mogelijk)
  </h1>
  <div class="d-grid gap-2">
    <button
      v-for="answer in answers"
      v-bind:key="answer"
      type="button"
      class="btn btn-lg text-light bg-field rounded-0"
      :class="[answerChecked(answer) ? 'btn-secondary' : 'btn-primary']"
      @click="addRemoveAnswer(answer)"
    >
      <i class="bi bi-square" v-if="!answerChecked(answer)"></i>
      <i class="bi bi-check-square" v-if="answerChecked(answer)"></i>
      {{ answer }}
    </button>
    <button
      type="button"
      class="btn btn-secondary text-dark btn-lg rounded-0"
      @click="saveAndGetQrCode()"
    >
      <span v-if="checkedAnswers.length < 1">Geen</span>
      <span v-if="checkedAnswers.length > 0">Volgende</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "questionFourScreen",
  data: () => ({
    answers: [
      "Meer websitebezoekers",
      "Nieuwe klanten",
      "Nieuwe sollicitanten",
      "Meer naamsbekendheid",
    ],
    checkedAnswers: [],
  }),
  computed: {},
  methods: {
    addRemoveAnswer(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        this.checkedAnswers.splice(this.checkedAnswers.indexOf(answer), 1);
      } else {
        this.checkedAnswers.push(answer);
      }
    },
    answerChecked(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        return true;
      }
      return false;
    },
    saveAndGetQrCode() {
      this.$store.commit("setQuestionFour", this.checkedAnswers);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";

h1 {
  font-size: 40px;
  color: $primary;
}
.bg-field {
  color: #fff !important;
}
</style>
